<template>
  <ul class="LeftBarSubButtons">
    <li class="LeftBarSubButton">
      <v-btn
        :class="`add-data ${index == 0 ? 'tour_leftbar_step1' : ''}`"
        :title="$t('common.title_addData')"
        fab
        x-small
        :disabled="!core.enableIdentify"
        @click.stop="
          gaClickAddData();
          core.matchingDialog.showAdvanced = showAdvanced;
          core.matchingDialog.data = data;
          core.matchingDialog.isCopy = false;
          core.matchingDialog.visible = true;
        "
        color="primaryButton"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </li>
    <!-- <li v-if="core.currentSelectedTableItem" class="LeftBarSubButton"> -->
    <li class="LeftBarSubButton">
      <v-btn
        :class="`copy-data ${index == 0 ? 'tour_leftbar_step2' : ''}`"
        :title="$t('common.title_copyData')"
        fab
        x-small
        @click.stop="
          gaClickCopyData();
          core.$refs.leftBarAddNCopy.resetData();
          core.matchingDialog.showAdvanced = showAdvanced;
          core.matchingDialog.data = data;
          core.matchingDialog.isCopy = true;
          core.matchingDialog.visible = true;
        "
        :disabled="
          !(core.tableItems.length > 0) ||
          !core.enableIdentify ||
          !core.currentSelectedTableItem
        "
        :color="core.currentSelectedTableItem ? 'primaryButton' : ''"
      >
        <v-icon>mdi-content-copy</v-icon>
      </v-btn>
    </li>
  </ul>
</template>

<script>
export default {
  props: ["core", "tour", "data", "showAdvanced", "index"],

  methods: {
    gaClickCopyData() {
      if (this.data.resultType == "identify") {
        this.$GA.identify_click_copy_item();
      } else if (this.data.resultType == "searchResult") {
        this.$GA.sr_click_copy_item();
      }
    },

    gaClickAddData() {
      if (this.data.resultType == "identify") {
        this.$GA.identify_click_add_item();
      } else if (this.data.resultType == "searchResult") {
        this.$GA.sr_click_add_item();
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.LeftBarSubButtons 
	text-align: right 
	padding: 0 10px 10px 0 
	list-style: none 
	margin: auto 
	.LeftBarSubButton 
		display: inline 
		margin: 0 2px 

</style>